/**
 * Meal calendar events never show the event title or time; the menu in the
 * description is the content. Shared by the full-page calendar list rows and
 * the Calendar Events grid cards so both layouts apply the same rule.
 */
export const showsEventTitleAndTime = (isMealCalendar: boolean): boolean => !isMealCalendar;
